var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.params.trigger_type.button.active == true
      ? _c(
          "span",
          {
            staticClass: "btn",
            class: _vm.params.trigger_type.button.cls,
            domProps: {
              innerHTML: _vm._s(_vm.params.trigger_type.button.html_content)
            },
            on: { click: _vm.save }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.params.trigger_type.button.content) +
                "\n    "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.params.trigger_type.close.active == true
      ? _c(
          "div",
          {
            staticClass: "close",
            class: _vm.params.trigger_type.close.cls,
            attrs: {
              type: "button",
              "data-dismiss": "alert",
              "aria-label": "Close"
            },
            on: { click: _vm.save }
          },
          [_vm._m(0)]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { attrs: { "aria-hidden": "true" } }, [
      _c("i", { staticClass: "fa fa-check" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89c3b21a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89c3b21a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/theme_manager/ThemeManager.vue
// module id = 539
// module chunks = 0